import React, { useEffect, useRef, useState, useCallback  } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button, Badge, Tooltip, OverlayTrigger, Dropdown } from "react-bootstrap";
import Drawer from '@mui/material/Drawer';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import DatePicker from "react-multi-date-picker";
import Edit from './../../../modal/Subscriber_Management/EditSubscriber';
import csv_ico from '../../../../images/export_icons/csv.ico';
import excel_ico from '../../../../images/export_icons/excel.ico';
import print_ico from '../../../../images/export_icons/print.ico';
import new_subs from '../../../../images/new_subs.gif';
import Drop from './../../../modal/Subscriber_Management/ProductDrop';
import Followup from './../../../modal/Subscriber_Management/Followup';
import Convert from './../../../modal/Subscription_Management/Manage_Order/ConvertSubscriber';

import axios from 'axios';

import * as XLSX from 'xlsx';
import Papa from 'papaparse';
const baseURL = process.env.REACT_APP_API_BASE_URL;

const getStartOfWeek = (date) => {
    const day = date.getDay(), // get the current day of the week
          diff = date.getDate() - day; // calculate the difference in days to the previous Sunday
    const startOfWeek = new Date(date.setDate(diff)); 
    startOfWeek.setHours(0, 0, 0, 0); // set to midnight
    return startOfWeek;
};

const getEndOfWeek = (date) => {
    const day = date.getDay(),
          diff = date.getDate() + (6 - day); // calculate the difference to the next Saturday
    const endOfWeek = new Date(date.setDate(diff));
    endOfWeek.setHours(23, 59, 59, 999); // set to the end of the day
    return endOfWeek;
};

const ManageOrder = () => {

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const [isVisible, setIsVisible] = useState({});

    const fetchData = useCallback((filter = { branch_id: branch_id }) => {
        axios.get(`${baseURL}/subscriber/orderdetails`, { params: filter })
            .then(response => {
                const fetchedData = response.data.data;
                setData(fetchedData);

                const visibilityMap = {};
                fetchedData.forEach(item => {
                    visibilityMap[item.lead_id] = false;
                });

                setIsVisible(visibilityMap);
                setHasFetched(true);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
                setHasFetched(true);
            });
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);


    const tableRef = useRef(null);

    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);
    const [selectedId, setSelecctedID] = useState("");

    const [data, setdata] = useState({});
    const fetchLeadSource = async (id) => {
        try {
            axios.get(`${baseURL}/leadsubscription/${id}`)
                .then(response => {
                    setdata(response.data.data);
                })
                .catch(error => {
                    console.log('There was an error fetching the data!', error);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const ConvertSubscriptionModal = (selectedId) => {
        setSelecctedID(selectedId);
        fetchLeadSource(selectedId);
        setModalType("RenewalSubscription");
        setOpen(true);
    };

    const handleModalToggle_Edit = (selectedId) => {
        setSelecctedID(selectedId);
        setModalType("Edit");
        setOpen(true);
    };

    const handleModalToggle_Drop = (selectedId) => {
        setSelecctedID(selectedId);
        setModalType("Drop");
        setOpen(true);
    };
    const [selected_data, setSelected_data] = useState({});
    const handleModalToggle_Followup = (selectedId, data) => {
        setSelecctedID(selectedId);
        setSelected_data(data);
        setModalType("Followup");
        setOpen(true);
    };

    // -------------------------------------------------------------- Filter Details ---------------------------
    const [filterOpen, setFilterOpen] = useState(false);

    //area
    const [areaOption, setAreaOption] = useState([]);
    const [area, setArea] = useState(null);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/area`, {params: {branch_id}});
                const formattedsource = response.data.data.map(item => ({
                value: item.sno,
                label: item.area_name,
                }));
                const allOption = { value: null, label: "All" };
                setAreaOption([allOption, ...formattedsource]);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    // delivery point
    const [dppoption, setdpoption] = useState([]);
    const [dp, setDp] = useState(null);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/deliverypoint`, {params: {branch_id}});
                const formattedsource = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.delivery_point,
                }));
                const allOption = { value: null, label: "All" };
                setdpoption([allOption, ...formattedsource]);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);
    

    // subs option & on select
    const [filter_subs_id, setFilterSubsID] = useState(null);
    const [subsribersOpt, setSubscribersOpt] = useState([]);
    useEffect(() => {
        axios.get(`${baseURL}/leadsubscription/subscribers`, {params: {branch_id}})
            .then(response => {
                const formatted = response.data.data.map(item => ({
                    value: item.lead,
                    label: item.lead_name,
                }));
                const allOption = { value: null, label: "All" };
                setSubscribersOpt([allOption, ...formatted]);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });
    }, []);

    const [filtermob_no, setFilterMob] = useState('');
    const [filteremail_id, setFilterEmail] = useState('');
    const [date_fil_selt_value, setDateFilSeltValue] = useState("all");
    const [today_fil_value, setTodayFilValue] = useState(new Date());
    const [week_stdt_fil_value, setWeekSTDTFilValue] = useState(getStartOfWeek(new Date()));
    const [week_eddt_fil_value, setWeekEDDTFilValue] = useState(getEndOfWeek(new Date()));
    const [month_fil_value, setMonthFilValue] = useState(new Date());
    const [custom_stdt_fil_value, setCustomSTDTFilValue] = useState(new Date());
    const [custom_eddt_fil_value, setCustomEDDTFilValue] = useState(new Date());

    // --------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------- export -----------------------------------//
    
    const exportCSV = () => {
        const columnNames = [
            'S.No', 'Lead Name', 'Mobile No', 'Email ID',
            'Lead Address', 'Product', 'Timeline', 'Start Date', 'End Date', 'Area', 'Delivery Point',
            'Total Delivery', 'Delivered', 'Balance Delivery'
        ];

        let serial = 1;

        const formattedData = datas.flatMap((lead) =>
            lead.products.map((product) => ({
                'S.No': serial++,
                'Lead Name': lead.lead_name || '-',
                'Mobile No': lead.lead_mobile || '-',
                'Email ID': lead.lead_email || '-',
                'Lead Address': product.address || lead.lead_address || '-',
                'Product': product.product_name || '-',
                'Timeline': product.duration_name + ' (' + product.duration_days + ' Days)' || '-',
                'Start Date': product.start_date || '-',
                'End Date': product.end_date || '-',
                'Area': product.area || '-',
                'Delivery Point': product.delivery_point || '-',
                'Total Delivery': product.total_delivery || 0,
                'Delivered': product.delivered || 0,
                'Balance Delivery': product.balance || 0,
            }))
        );
        const csv = Papa.unparse({
            fields: columnNames,
            data: formattedData
        });
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'subscrption.csv';
        link.click();
    };

    const exportExcel = () => {
        let serial = 1;

        const formattedData = datas.flatMap((lead) =>
            lead.products.map((product) => ({
                'S.No': serial++,
                'Lead Name': lead.lead_name || '-',
                'Mobile No': lead.lead_mobile || '-',
                'Email ID': lead.lead_email || '-',
                'Lead Address': product.address || lead.lead_address || '-',
                'Product': product.product_name || '-',
                'Timeline': product.duration_name + ' (' + product.duration_days + ' Days)' || '-',
                'Start Date': product.start_date || '-',
                'End Date': product.end_date || '-',
                'Area': product.area || '-',
                'Delivery Point': product.delivery_point || '-',
                'Total Delivery': product.total_delivery || 0,
                'Delivered': product.delivered || 0,
                'Balance Delivery': product.balance || 0,
            }))
        );
    
        // Create worksheet from formatted data
        const ws = XLSX.utils.json_to_sheet(formattedData);
    
        // Create a new workbook and append the worksheet
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    
        // Write the workbook to an Excel file and trigger the download
        XLSX.writeFile(wb, 'subscription.xlsx');
    };

    const print = () => {
            // Define the column names for printing
        const columnNames = [
            'S.No', 'Lead Name', 'Mobile No', 'Email ID',
            'Lead Address', 'Product', 'Timeline', 'Start Date', 'End Date', 'Area', 'Delivery Point',
            'Total Delivery', 'Delivered', 'Balance Delivery'
        ];

        let serial = 1;

        const formattedData = datas.flatMap((lead) =>
            lead.products.map((product) => ({
                'S.No': serial++,
                'Lead Name': lead.lead_name || '-',
                'Mobile No': lead.lead_mobile || '-',
                'Email ID': lead.lead_email || '-',
                'Lead Address': product.address || lead.lead_address || '-',
                'Product': product.product_name || '-',
                'Timeline': product.duration_name + ' (' + product.duration_days + ' Days)' || '-',
                'Start Date': product.start_date || '-',
                'End Date': product.end_date || '-',
                'Area': product.area || '-',
                'Delivery Point': product.delivery_point || '-',
                'Total Delivery': product.total_delivery || 0,
                'Delivered': product.delivered || 0,
                'Balance Delivery': product.balance || 0,
            }))
        );

        // Create an HTML table for printing
        let printContent = `<table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
            <thead>
                <tr style="background-color: #f2f2f2;">`;

        // Add column headers
        columnNames.forEach(col => {
            printContent += `<th style="padding: 8px; text-align: left; border: 1px solid #ddd;">${col}</th>`;
        });

        printContent += `</tr></thead><tbody>`;

        // Add the rows of data
        formattedData.forEach(row => {
            printContent += `<tr>`;
            columnNames.forEach(col => {
                printContent += `<td style="padding: 8px; border: 1px solid #ddd;">${row[col]}</td>`;
            });
            printContent += `</tr>`;
        });

        printContent += `</tbody></table>`;

        // Open the print dialog
        const printWindow = window.open('', '', 'height=800,width=1000');
        printWindow.document.write('<html><head><title>Subscription Details</title>');
        printWindow.document.write('<style>table { width: 100%; border-collapse: collapse; }</style>');
        printWindow.document.write('</head><body>');
        printWindow.document.write(printContent);
        printWindow.document.write('</body></html>');
        printWindow.document.close(); // Necessary for IE >= 10
        printWindow.print();
    };

    const onClose = () => {
        setFilterOpen(false);
    };

    const date_fil_options = [
        { value: "all", label: "All" },
        { value: "today", label: "Today" },
        { value: "this_week", label: "This week" },
        { value: "this_month", label: "This Month" },
        { value: "custom", label: "Custom Date" }
    ];

    const toggleDiv = (leadId) => {
        setIsVisible(prev => ({
            ...prev,
            [leadId]: !prev[leadId]
        }));
    };

    useEffect(() => {
        if (datas.length === 0 && hasFetched) {
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "responsive": true,
                        //   "aaSorting": [],
                        pageLength: 25,
                        "ordering": false,
                        "language": {
                            "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [hasFetched, datas.length]);


    const checkdate = (date) => {
        const isToday = new Date(date).toDateString() === new Date().toDateString();
        return isToday;
    }

    const handleStatusToggle = async (id, currentStatus) => {
        const newStatus = currentStatus === 0 ? 1 : 0;
        axios.put(`${baseURL}/subscriber/status/${id}`, {status: newStatus})
            .then(response => {
                // window.location.reload();
            })
            .catch(error => {
                console.log(error);
            });
    };

    const handleGoClick = () => {
        
        const filter = {
            lead: filter_subs_id || '',
            lead_email_id: filteremail_id || '',
            lead_mobile_no: filtermob_no || '',
            area: area || '',
            delivery_point: dp || '',
            date_filter: date_fil_selt_value || '',
        };
        if (date_fil_selt_value === 'custom') {
            filter.start_date = custom_stdt_fil_value || '';
            filter.end_date = custom_eddt_fil_value || '';
        }
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }        
        fetchData(filter);
        onClose();
        // window.location.reload();
    };

    // check the start date is in future
    function isDateInFuture(dateStr) {
        // dateStr format: "DD-MM-YYYY"
        const [day, month, year] = dateStr.split('-').map(Number);

        // Create a Date object for the given date (months are 0-based)
        const givenDate = new Date(year, month - 1, day);

        // Create a Date object for today, set time to 00:00:00 to only compare dates
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        return givenDate > today;
    }

    // check the current date is in hold
    function isTodayInDateList(dateString) {
        // Split the string by comma, trim spaces just in case
        const dates = dateString.split(',').map(d => d.trim());

        // Get today's date string in "DD-MM-YYYY" format
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0'); // month is 0-based
        const year = today.getFullYear();
        const todayStr = `${day}-${month}-${year}`;

        // Check if today's date string is in the array
        return dates.includes(todayStr);
    }



    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Manage Order</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Subscription Management</li>
                    </ol>
                </div>

                <div className='d-flex align-items-center gap-3'>
                    
                    <Link to={"#"} className="btn btn-primary float-end btn-sm" onClick={() => setFilterOpen(true)}>
                        <span className='me-2'><i className="fa-solid fa-filter fs-8"></i></span>
                        <span className=''>Filter</span>
                    </Link>
                    <Dropdown>
                        <Dropdown.Toggle
                            as="button"
                            variant="primary"
                            className="btn btn-primary text-white btn-sm"
                            id="tp-btn"
                        >
                            <span className='me-2'><i className="fa-solid fa-circle-down fs-8"></i></span>
                            <span className=''>Export</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={exportCSV} className='px-2'>
                                <img
                                    src={csv_ico}
                                    alt="CSV"
                                    className='w-30px h-30px'
                                />
                                <span className='fs-7 ms-2 font-w500 text-black'>CSV</span>
                            </Dropdown.Item>
                            <Dropdown.Item onClick={exportExcel} className='px-2'>
                                <img
                                    src={excel_ico}
                                    alt="Excel"
                                    className='w-30px h-30px'
                                />
                                <span className='fs-7 ms-2 font-w500 text-black'>Excel</span>
                            </Dropdown.Item>
                            <Dropdown.Item onClick={print} className='px-2'>
                                <img
                                    src={print_ico}
                                    alt="Print"
                                    className='w-30px h-30px'
                                />
                                <span className='fs-7 ms-2 font-w500 text-black'>Print</span>
                            </Dropdown.Item>
                            {/* <Link to={'//PrintTripSheet'} className="btn btn-primary float-end btn-sm">
                                <span className='me-2'><i className="fa-solid fa-angle-left fs-8"></i></span>
                                <span className=''>Add Vehicle</span>
                            </Link> */}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                {open && modalType === "Edit" && (
                    <Edit show={open} onClose={() => setOpen(false)} selectedId={selectedId} refresh={fetchData} />
                )}
                {open && modalType === "Drop" && (
                    <Drop show={open} onClose={() => setOpen(false)} selectedId={selectedId} refresh={fetchData} />
                )}
                {open && modalType === "Followup" && (
                    <Followup show={open} onClose={() => setOpen(false)} selectedId={selectedId} data={selected_data} refresh={fetchData} />
                )}
                {open && modalType === "RenewalSubscription" && (
                    <Convert show={open} onClose={() => setOpen(false)} data={data} refresh={fetchData} />
                )}
            </div>

            <div className='row mb-3'>
                <div className='d-flex align-items-end justify-content-end'>
                    <div className='col-lg-8 d-flex align-items-center justify-content-end'>
                        
                        <div className="d-flex align-items-center px-1 py-1">
                            <label className=" rounded border border-dark w-25px h-25px me-1" style={{ backgroundColor: 'rgb(136, 228, 184, 0.4)' }}> </label>
                            <label className="fs-7 fw-semibold text-black">Active</label>
                        </div>
                        <div className="d-flex align-items-center px-1 py-1">
                            <label className=" rounded border border-dark w-25px h-25px me-1" style={{ backgroundColor: '#D3D3D3' }}> </label>
                            <label className="fs-7 fw-semibold text-black">Hold</label>
                        </div>
                        <div className="d-flex align-items-center px-1 py-1">
                            <label className=" rounded border border-dark w-25px h-25px me-1" style={{ backgroundColor: '#c4eefc' }}> </label>
                            <label className="fs-7 fw-semibold text-black">Future</label>
                        </div>
                        <div className="d-flex align-items-center px-1 py-1">
                            <label className=" rounded border border-dark w-25px h-25px me-1" style={{ backgroundColor: 'rgba(240, 175, 175, 0.5)' }}> </label>
                            <label className="fs-7 fw-semibold text-black">Delivered</label>
                        </div>
                        
                    </div>
                </div>
            </div>
            
            <div className="table-container">
                
                {datas.length === 0 && hasFetched && (
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        {/* Left: Show entries dropdown */}
                        <div>
                            <label className="me-2">Show</label>
                            <select
                                className="form-select d-inline w-auto"
                                style={{  fontSize: '0.85rem', height: '30px' }}
                            >
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                        </div>

                        {/* Right: Search input */}
                        <div>
                            <input
                                type="text"
                                style={{  fontSize: '0.85rem', height: '40px' }}
                                placeholder="Search..."
                                className="form-control"
                            />
                        </div>
                    </div>
                )}

                <table className="table align-top table-row-dashed table-striped fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd' }}>
                    <thead>
                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                            <th className='min-w-100px'>Subscribers</th>
                            <th className='min-w-100px'>Email ID / Mobile</th>
                            <th className='min-w-100px'>Address</th>
                            <th className='min-w-50px text-center'>Subscription Count</th>
                            <th className='min-w-50px text-center'>Subscription Score</th>
                            <th className='min-w-50px text-end'>Actions</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-semibold fs-7">
                        {datas.length === 0 && hasFetched ? (
                            <tr>
                                <td colSpan="7" className="text-center text-muted py-2">
                                    No data available
                                </td>
                            </tr>
                        ) : (
                            <>
                                {datas.map((data, index) => (
                                    <React.Fragment key={data.lead_id}>
                                        <tr style={isVisible[data.lead_id] ? { backgroundColor: '#fff0f0' } : {}} key={data.lead_id}>
                                            <td>
                                                <div className='d-flex align-items-center'>
                                                    <Button variant="primary tp-btn-light border px-2 pt-1 pb-0 me-1" onClick={() => toggleDiv(data.lead_id)}>
                                                        {isVisible[data.lead_id] ? (
                                                            <span><i className="fa-solid fa-angle-down fs-4"></i></span>
                                                        ) : (
                                                            <span><i className="fa-solid fa-angle-right fs-4"></i></span>
                                                        )}
                                                    </Button>
                                                    <div className='text-black font-w400 fs-7 ms-2'>{data.lead_name}</div>
                                                </div>
                                                {checkdate(data.created_at) && (
                                                    <div className='d-block'>
                                                        <img src={new_subs} alt="New Customer" className='cursor-pointer w-65px h-20px' />
                                                    </div>
                                                )}
                                                {data.expired_count > 0 && (
                                                    <div className='mt-2'>
                                                        <Badge bg="danger" className='text-white fs-8 py-0 px-1'>{data.expired_count} Delivered</Badge>
                                                    </div>
                                                )}
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>{data.lead_mobile}</label>
                                                <div className='d-block'>
                                                    <label className='text-black font-w400 fs-8'>{data.lead_email ? data.lead_email : '-'}</label>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='text-black font-w400 fs-7 w-200px text-wrap'>{data.lead_address ? data.lead_address : '-'}</div>
                                            </td>
                                            <td className='text-center'>
                                                <Badge bg="info" className='py-0 px-1 fs-8'>{data.product_count}</Badge>
                                            </td>
                                            <td className='text-center'>
                                                <Badge bg="success" className='py-0 px-1 fs-8'>{data.score}</Badge>
                                            </td>
                                            <td>
                                                <span className="text-end">
                                                    <Dropdown drop=''>
                                                        <Dropdown.Toggle
                                                            as="a"
                                                            className="i-false cursor-pointer"
                                                        >
                                                            <Button variant="primary tp-btn-light px-3 py-2">
                                                                <span><i className="fa-solid fa-ellipsis-vertical fs-6 mt-1"></i></span>
                                                            </Button>
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                                <Dropdown.Item as={Link} to={`/add-subscriptions/${data.lead_id}`}  className='px-2 py-1'>
                                                                    <div className='d-flex align-items-center'>
                                                                        <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                                            <span><i className="fa-solid fa-handshake fs-5 text-danger"></i></span>
                                                                        </div>
                                                                        <div className="ms-1 fs-7">New Subscription</div>
                                                                    </div>
                                                                </Dropdown.Item>
                                                                <Dropdown.Item as={Link} to="/view-subscriber-details" state={{ ID: data.lead_id }} className='px-2 py-1'>
                                                                    <div className='d-flex align-items-center'>
                                                                        <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                                            <span><i className="fa-solid fa-eye fs-5 text-danger"></i></span>
                                                                        </div>
                                                                        <div className="ms-1 fs-7">View Subscriber</div>
                                                                    </div>
                                                                </Dropdown.Item>
                                                                <Dropdown.Item href={"#"} className='px-2 py-1' onClick={() => handleModalToggle_Edit(data.lead_id)}>
                                                                    <div className='d-flex align-items-center'>
                                                                        <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                                            <span><i className="fa-solid fa-pen-to-square fs-5 text-danger"></i></span>
                                                                        </div>
                                                                        <div className="ms-2 fs-7">Edit Subscriber</div>
                                                                    </div>
                                                                </Dropdown.Item>
                                                            {data?.products?.filter(product => product.balance <= 3 && (product.status == 3 || product.status == 5)).length > 0 && (
                                                                <Dropdown.Item href={"#"} className='px-2 py-1' onClick={() => handleModalToggle_Followup(data.lead_id, data)}>
                                                                    <div className='d-flex align-items-center'>
                                                                        <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                                            <span><i className="fa fa-bell fs-5 text-danger"></i></span>
                                                                        </div>
                                                                        <div className="ms-2 fs-7">Renewal Followup</div>
                                                                    </div>
                                                                </Dropdown.Item>
                                                            )}
                                                            {data?.products?.filter(product => product.status == 3).length > 0 && (
                                                                <Dropdown.Item href={"#"} className='px-2 py-1' onClick={() => handleModalToggle_Drop(data.lead_id)}>
                                                                    <div className='d-flex align-items-center'>
                                                                        <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                                            <span><i className="fa-solid fa-ban fs-5 text-danger"></i></span>
                                                                        </div>
                                                                        <div className="ms-2 fs-7">Drop Product</div>
                                                                    </div>
                                                                </Dropdown.Item>
                                                            )}
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </span>
                                            </td>
                                        </tr>
                                        {isVisible[data.lead_id] && (
                                            <>
                                                <tr style={{backgroundColor:'#ffffff'}} key={data.sno}>
                                                    <td colSpan={7}>
                                                        <div className='d-flex align-item-top'>
                                                            <div className='fs-7 border border-gray-800 border-end-0 p-2' style={{ color: 'black', fontWeight: '600', width: '23%' }}>Name / Contact</div>
                                                            <div className='fs-7 border border-gray-800 border-end-0 p-2' style={{ color: 'black', fontWeight: '600', width: '23%' }}>Date</div>
                                                            <div className='fs-7 border border-gray-800 border-end-0 p-2' style={{ color: 'black', fontWeight: '600', width: '23%' }}>Product</div>
                                                            <div className='fs-7 border border-gray-800 border-end-0 p-2' style={{ color: 'black', fontWeight: '600', width: '23%' }}>Duration</div>
                                                            <div className='fs-7 border border-gray-800 border-end-0 p-2 text-end' style={{ color: 'black', fontWeight: '600', width: '15%' }}>Amount</div>
                                                            <div className='fs-7 border border-gray-800 border-end-0 p-2' style={{ color: 'black', fontWeight: '600', width: '15%' }}>Delivery Point</div>
                                                            <div className='fs-7 border border-gray-800 border-end-0 p-2 text-center' style={{ color: 'black', fontWeight: '600', width: '15%' }}>Delivery Count</div>
                                                            <div className='fs-7 border border-gray-800 p-2 text-center' style={{ color: 'black', fontWeight: '600', width: '15%' }}>Action</div>
                                                        </div>
                                                        {data.products.map((prod, index) => (
                                                            <div key={index} className={
                                                                prod.status === 5 || prod.status === 4
                                                                ? 'd-flex align-item-top bg-danger-slight'
                                                                : isDateInFuture(prod.start_date)
                                                                ? 'd-flex align-item-top bg-info-slight'
                                                                : (prod.hold_dates || prod.hold_count > 0) && isTodayInDateList(prod.hold_dates)
                                                                ? 'd-flex align-item-top bg-gray-slight'
                                                                : prod.status === 3
                                                                ? 'd-flex align-item-top bg-success-slight'
                                                                : 'd-flex align-item-top'
                                                            }>
                                                                <div className='fs-7 border border-top-0 border-end-0 border-gray-800 p-2' style={{ color: 'black', fontWeight: '600', width: '23%' }}>
                                                                    <label className='text-black fw-bold fs-7'>{prod.delivery_person}</label>
                                                                    <div className="d-block">
                                                                        <div className="fs-8 text-dark font-w500 text-wrap mw-auto">{prod.delivery_contact}</div>
                                                                    </div>
                                                                </div>
                                                                <div className='fs-7 border border-top-0 border-end-0 border-gray-800 p-2' style={{ color: 'black', fontWeight: '600', width: '23%' }}>
                                                                    <label className='text-success fw-bold fs-7'>{prod.created_at}</label>
                                                                </div>
                                                                <div className='fs-7 border border-top-0 border-end-0 border-gray-800 p-2' style={{ color: 'black', fontWeight: '600', width: '23%' }}>
                                                                    <div className='text-black font-w400 fs-7 text-wrap mw-auto'>{prod.product_name}</div>
                                                                    <div className="d-block">
                                                                        <div className="fs-8 text-dark font-w500 text-wrap mw-auto">{prod.duration_name} ( {prod.duration_days} Days )</div>
                                                                    </div>
                                                                </div>
                                                                <div className='fs-7 border border-top-0 border-end-0 border-gray-800 p-2' style={{ color: 'black', fontWeight: '600', width: '23%' }}>
                                                                    <label className='text-success fw-bold fs-7'>{prod.start_date}</label>
                                                                    <div className='d-block'>
                                                                        <label className='text-danger fw-bold fs-7'>{prod.end_date}</label>
                                                                    </div>
                                                                </div>
                                                                <div className='fs-7 border border-top-0 border-end-0 border-gray-800 p-2 text-end' style={{ color: 'black', fontWeight: '600', width: '15%' }}>
                                                                    <label className='text-danger fw-bold fs-7'>
                                                                        <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                                        <span>{prod.product_amount}</span>
                                                                    </label>
                                                                </div>
                                                                <div className='fs-7 border border-top-0 border-end-0 border-gray-800 p-2' style={{ color: 'black', fontWeight: '600', width: '15%' }}>
                                                                    <div className='text-black font-w400 fs-7 text-wrap mw-auto'>{prod.delivery_point}</div>
                                                                </div>
                                                                <div className='border-top-0 fs-7 border border-top-0 border-end-0 border-gray-800 p-2' style={{color:'black', fontWeight:'600',width:'15%'}}>
                                                                    <div className='d-flex align-items-center gap-2 flex-wrap justify-content-center'>
                                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Balance Delivery</span></Tooltip>} >
                                                                            <Badge bg="danger" className='text-white fs-8 py-0 px-1 cursor-pointer'>{prod.balance}</Badge>
                                                                        </OverlayTrigger>
                                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Delivered</span></Tooltip>} >
                                                                            <Badge bg="success" className='text-white fs-8 py-0 px-1 cursor-pointer'>{prod.delivered}</Badge>
                                                                        </OverlayTrigger>
                                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Total Delivery</span></Tooltip>} >
                                                                            <Badge bg="info" className='text-white fs-8 py-0 px-1 cursor-pointer'>{prod.total_delivery}</Badge>
                                                                        </OverlayTrigger>
                                                                    </div>
                                                                    {prod.status === 4 && (
                                                                        <div className='text-center mt-2'>
                                                                            <Badge bg="none" className='text-white fs-8 py-0 px-1' style={{ backgroundColor: '#c0392b' }}>Drop</Badge>
                                                                        </div>
                                                                    )}
                                                                    {prod.status === 5 && (
                                                                        <div className='text-center mt-2'>
                                                                            <Badge bg="success" className='text-white fs-8 py-0 px-1'>Delivered</Badge>
                                                                        </div>
                                                                    )}
                                                                    {prod.hold_count > 0 && (
                                                                        <div className='text-center mt-1'>
                                                                            <Dropdown drop='start'>
                                                                                <Dropdown.Toggle
                                                                                    as="a"
                                                                                    className="i-false cursor-pointer"
                                                                                >
                                                                                    <Button variant="bg-none py-0 px-0">
                                                                                        <span className='fs-8 bg-warning px-1 border border-dark rounded font-w500 text-black'>{prod.hold_count} Days Hold</span>
                                                                                    </Button>
                                                                                </Dropdown.Toggle>
                                                                                <Dropdown.Menu className='mw-100 flex-wrap text-wrap px-2 bg-warning'>
                                                                                    <div className='d-block fs-7 font-w500 text-black text-center bg-white rounded mb-2'>Hold</div>
                                                                                    {prod.hold_dates && prod.hold_dates.split(',').map((date, index) => (
                                                                                        <div key={index} className='d-block fs-7 font-w500 text-black'>
                                                                                            {date}
                                                                                        </div>
                                                                                    ))}
                                                                                </Dropdown.Menu>
                                                                            </Dropdown>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <div className='border-top-0 fs-7 border border-gray-800 p-2 text-center' style={{ color: 'black', fontWeight: '600', width: '15%' }}>
                                                                    {prod.is_relative === 1 ? (
                                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom"
                                                                        overlay={ <Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Convert Subscriber</span> </Tooltip>}>
                                                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => ConvertSubscriptionModal(prod.product_id)}>
                                                                            <span><i className="fa-solid fa-people-carry-box fs-4 mt-1"></i></span>
                                                                        </Button>
                                                                    </OverlayTrigger>
                                                                    ) : (
                                                                        <div className="text-center">
                                                                            No Actions
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </td>
                                                </tr>
                                            </>
                                        )}
                                    </React.Fragment>
                                ))}
                            </>
                        )}
                    </tbody>
                </table>
                
                {datas.length === 0 && hasFetched && (
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        {/* Bottom left: Showing x to y of z entries */}
                        <div>
                            <span className="text-muted">
                                Showing 0 to 0 of 0 entries
                            </span>
                        </div>

                        {/* Bottom right: Pagination */}
                        <nav>
                            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                <li className={`page-item disabled`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} >Previous</button>
                                </li>
                                
                                <li key={1} className={`page-item active`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} >1</button>
                                </li>
                                
                                <li className={`page-item disabled`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} >Next</button>
                                </li>
                            </ul>
                        </nav>

                    </div>
                )}
            </div>


            <Drawer
                anchor="right"
                open={filterOpen}
                onClose={() => setFilterOpen(false)}
                disableEscapeKeyDown
                BackdropProps={{
                    onClick: (e) => e.stopPropagation(), 
                }}
                sx={{
                    width: 400,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                    width: 400, 
                    boxSizing: 'border-box',
                    },
                    '@media (max-width: 375px)': {
                    '& .MuiDrawer-paper': {
                        width: 320,
                    },
                    },
                    '@media (max-width: 320px)': {
                    '& .MuiDrawer-paper': {
                        width: 280, 
                    },
                    },
                }}
                >
                <div className='modal-header mb-0 px-4 pt-2 pb-0'>
                    <h5 className='fs-4' style={{ color: '#ea1d25' }}>Subscribers Filter</h5>
                    <div>
                    <Button variant="" type="button" size='sm' data-dismiss="modal" onClick={onClose}>
                        <span className='fs-2'>×</span>
                    </Button>
                    </div>
                </div>
                <div className='card border-0'>
                    <div className='card-body py-0'>
                        <div className='row mb-2 py-2'>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Subscribers</label>
                                <Select 
                                    value={subsribersOpt.find(option => option.value === filter_subs_id) || null}
                                    onChange={(selectedOption) => setFilterSubsID(selectedOption.value)}
                                    options={subsribersOpt}
                                    placeholder="Select Subscribers"
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Email ID</label>
                                <input type="text" className="form-control" placeholder="Enter Email ID" 
                                    value={filteremail_id}
                                    onChange={(e) => setFilterEmail(e.target.value)}/>
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Mobile No</label>
                                <input type="text" className="form-control" placeholder="Enter Mobile No" 
                                    value={filtermob_no}
                                    onChange={(e) => {
                                        const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                        setFilterMob(onlyNums);
                                    }}
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Area</label>
                                <Select 
                                    value={areaOption.find(option => option.value === area) || null}
                                    options={areaOption}
                                    onChange={(selectedOption) => setArea(selectedOption.value)}
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Delivery Point</label>
                                <Select 
                                    value={dppoption.find(option => option.value === dp) || null}
                                    onChange={(selectedOption) => setDp(selectedOption.value)}
                                    options={dppoption}
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Date</label>
                                <Select
                                    value={date_fil_options.find(option => option.value === date_fil_selt_value)}
                                    onChange={(selectedOption) => setDateFilSeltValue(selectedOption.value)}
                                    options={date_fil_options}
                                    menuPlacement="top"
                                />
                            </div>
                            {date_fil_selt_value === "all" && <></>}
                            {date_fil_selt_value === "today" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">Today</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            // value={"05/18/2020 02:20:36 PM"}
                                            value={today_fil_value}
                                            onChange={setTodayFilValue}
                                            format="DD-MM-YYYY"
                                            // format="DD/MM/YYYY hh:mm:ss A"
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "this_week" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_stdt_fil_value}
                                                onChange={setWeekSTDTFilValue}
                                                format="DD-MM-YYYY"
                                                readOnly={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_eddt_fil_value}
                                                onChange={setWeekEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                                readOnly={true}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                            {date_fil_selt_value === "this_month" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">This Month</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            value={month_fil_value}
                                            onChange={setMonthFilValue}
                                            format="MMM-YYYY"
                                            calendarPosition="top"
                                            mode="single"
                                            onlyMonthPicker={true}
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "custom" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_stdt_fil_value}
                                                onChange={setCustomSTDTFilValue}
                                                format="DD-MM-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_eddt_fil_value}
                                                onChange={setCustomEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-1">
                        <Button className="me-2 btn-sm" variant="secondary" onClick={() =>{
                            setFilterSubsID(null);
                            setFilterMob('');
                            setFilterEmail('');
                            setArea(null);
                            setDp(null);
                            setDateFilSeltValue('all');
                            onClose();
                            setHasFetched(false);
                            if ($.fn.dataTable.isDataTable(tableRef.current)) {
                                $(tableRef.current).DataTable().destroy();
                            }        
                            fetchData();
                            // window.location.reload();
                        }}>
                            <span className='font-w400'>Reset</span>
                        </Button>
                        <Button className="me-2 btn-sm" variant="primary" onClick={handleGoClick}>
                            <span className='font-w400'>Go</span>
                        </Button>
                    </div>
                </div>
            </Drawer>

        </>
    )
}
export default ManageOrder;


